/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Impersonate_User_TitleInputs */

const en_admin_company_detail_impersonate_user_title = /** @type {(inputs: Admin_Company_Detail_Impersonate_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impersonate User`)
};

const de_admin_company_detail_impersonate_user_title = /** @type {(inputs: Admin_Company_Detail_Impersonate_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Benutzer anmelden`)
};

/**
* | output |
* | --- |
* | "Impersonate User" |
*
* @param {Admin_Company_Detail_Impersonate_User_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_impersonate_user_title = /** @type {((inputs?: Admin_Company_Detail_Impersonate_User_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Impersonate_User_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_impersonate_user_title(inputs)
	return en_admin_company_detail_impersonate_user_title(inputs)
});